/**=========================================================
 * Module: app-tooltip.js
 * Tooltip
 =========================================================*/

 App.directive('appTooltip', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/tooltip.html',
      controller: 'TooltipController',
      restrict: 'E',
      replace: true,
      scope: {
        pid: '@',
        tid: '@',
        wait: '@',
        position: '@',
        size: '@',
        arrowSize: '@',
        arrowPosition: '@',
        startClose: '@'
      }
  };

});